import React, { useCallback, useEffect } from 'react';
import SearchBar from '../../../SearchBar/SearchBar'
import Logo from '../../../Logo/Logo'
import { HashLink } from 'react-router-hash-link';
import IconWrapper from '../../../Icons/IconWrapper'
import CursorIcon from '../../../Icons/CursorRight/CursorRight'
import {
    WerfenFormFieldColor,
    WerfenFormIconBackgroundColor,
    WerfenFormIconColor,
    WerfenFormTextColor,
    White
} from '../../../../Constants/ColorChart'
import { Col, Container, Row } from 'react-bootstrap'
import ProfileIcon from '../../../ProfileIcon/ProfileIcon'
import { hideAutoSuggest } from "../../../../../actions/ui";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { setSearchString, setSuggestString } from "../../../../../actions/search";
import { RecentActivityIcon }  from "../../../RecentActivityIcon/RecentActivityIcon";
import RecentActivity from "../../../RecentActivity/Logic/RecentActivity";
import { recentActivityAPI } from "../../../RecentActivity/Logic/recentActivityAPI";
import { frequentlyUsedAPI} from "../../../RecentActivity/Logic/recentActivityAPI";
import { WrapperDiv, SearchBox, LogoWrapper, RightButtonDiv } from "./StyledSearchSection";
/*
 *  @Description:   Stateless component that renders a Section with the Business Line filters, a Searchbar and the autosuggestions.
 *                  It will also present a button on the upper-right corner that will route to the user at the
 *                  profile menu.
 *                  If the user click at the lower icon of this section, the screen will be scrolled 
 *                  smoothly to the CaptionSection.
 */


const SearchSection = ( props ) => {
    const [activityTabBarOpen, setTabBarOpen] = React.useState( false );
    const handleActivity = () => {
        setTabBarOpen( !activityTabBarOpen );
    }
    useEffect ( () => {
        document.querySelector ( "#SearchSection" ).scrollTo ( { top: 0, behavior: 'smooth' } );
        document.querySelectorAll ( "#searchBar" )[0].value = "";
        props.hideAutoSuggest ();
        props.setSearchString ( "" );
        props.setSuggestString ( "" );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const getRecentActivity = useCallback(() => {
        return recentActivityAPI();
    }, []);

const getFrequentlyUsed = useCallback(() => {
    return frequentlyUsedAPI();
}, []);

    return (
        <WrapperDiv id="SearchSection">
            <RightButtonDiv>
                <RecentActivityIcon
                    handleActivity={ handleActivity }
                    search={true}
                />
                <ProfileIcon/>
            </RightButtonDiv>
            {activityTabBarOpen  && <RecentActivity
                recentActivityAPI={ getRecentActivity }
                frequentlyUsedAPI={ getFrequentlyUsed }
            />}
            <Container>
                <Row>
                    <Col
                        lg={ { span: 12, offset: 0 } }
                        xs={ { span: 10, offset: 1 } }
                    >
                        <SearchBox className={ "SearchBox" }>
                            <LogoWrapper className="LogoWrapper">
                                <Logo/>
                            </LogoWrapper>
                            <div className="SearchBarContainer">
                                <SearchBar
                                    background={ WerfenFormFieldColor }
                                    buttonBackgroundColor={ WerfenFormIconBackgroundColor }
                                    buttonIconColor={ WerfenFormIconColor }
                                    className="SearchBar"
                                    iconBottom={ false }
                                    extraStyle={ { height: "55px" } }
                                    color={ WerfenFormTextColor }
                                    placeholder="What are you looking for?"
                                />
                            </div>
                        </SearchBox>
                    </Col>
                </Row>
                <Row>
                    <HashLink
                        to="/#outstandingSection"
                        name="scroll to the next section"
                        scroll={ el => el.scrollIntoView ( {
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        } ) }
                        data-title="Scroll to the next section"

                    >
                        Scroll to the next section
                        <IconWrapper
                            color={ White }
                            width="30px"
                            iconStyle="position: absolute; transform: rotate(90deg); bottom: 5px; height:30px; left: calc(50% - 20.5px);"
                            strokeWidth={"20px"}
                            Icon={ CursorIcon }
                        />
                    </HashLink>
                </Row>
            </Container>
        </WrapperDiv>
    );
}

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        hideAutoSuggest: hideAutoSuggest,
        setSearchString: setSearchString,
        setSuggestString: setSuggestString,
    }, dispatch );
};

export default connect ( null, mapDispatchToProps ) ( SearchSection );
